import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=5347bd7e&scoped=true&"
import script from "./EditUser.vue?vue&type=script&lang=ts&"
export * from "./EditUser.vue?vue&type=script&lang=ts&"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=5347bd7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347bd7e",
  null
  
)

export default component.exports